import { SceneLightData } from './sceneLightData';

export class ModelIlluminationData {

  // Lights
  lights: SceneLightData[] = [];

  // Environment
  environmentIntensity = 0.0;
}
